import type { ExperimentClient } from "@amplitude/experiment-js-client";
import { type Context, createContext } from "react";

type Result<T> = { active: true; payload: T } | { active: false };

type ContextValue = {
	isVariantActive: <T>(key: string, activeValue?: string) => Result<T>;
	isControlActive: <T>(key: string, activeValue?: string) => Result<T>;
};

export const offContextValue: ContextValue = {
	isVariantActive: (_key, _activeValue?) => ({ active: false }),
	isControlActive: (_key, _activeValue?) => ({ active: false }),
};

export const liveContextValue = (client: ExperimentClient): ContextValue => {
	const isVariantActive = <T>(key: string, activeValue?: string): Result<T> => {
		const { value = "control", payload } = client.variant(key);
		const active = activeValue ? value === activeValue : value !== "control";
		return { active, payload };
	};

	const isControlActive = <T>(
		key: string,
		activeValue = "control",
	): Result<T> => {
		return isVariantActive(key, activeValue);
	};

	return { isVariantActive, isControlActive };
};

export const context: Context<ContextValue> = createContext(offContextValue);
export const Provider = context.Provider;
